import PasswordRecoveryRequest from "./PasswordRecoveryRequest";

export default PasswordRecoveryRequest;
